import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const PAGE_NAMES = {
  "/": "Agenda",
  "/appointments/new": "Crea un nuovo appuntamento",
  "/agenda-tools": "Gestisci orari staff",
  "/lab/availability": "Disponibilità",
  "/customers": "Clienti",
  "/services": "Servizi",
  "/staff": "Staff",
  "/business-profile": "Profilo attività",
  "/business-hours": "Orari",
  "/activity": "Registro attività",
  "/owner-alerts": "Avvisi",
  "/recovery": "Recupero",
  "/customer-inbox-lab": "Messaggi Lab",
  "/trash": "Cestino",
  "/login": "Accesso",
};

export function getSpaPageName(pathname) {
  if (pathname.startsWith("/book/")) {
    return "Prenotazione online";
  }
  if (pathname.includes("/reminders/confirm/")) {
    return "Conferma appuntamento";
  }
  if (pathname.includes("/reminders/cancel/")) {
    return "Annullamento appuntamento";
  }
  if (pathname.includes("/recovery/confirm/")) {
    return "Conferma recupero";
  }
  return PAGE_NAMES[pathname] || "Pagina";
}

function getMainContent() {
  return document.getElementById("main-content") || document.querySelector("main");
}

function focusElement(element) {
  if (!element) return;
  if (!element.hasAttribute("tabindex")) {
    element.setAttribute("tabindex", "-1");
  }
  element.focus({ preventScroll: true });
}

function focusNewRouteContent() {
  const main = getMainContent();
  const title = main?.querySelector('[data-spa-page-title="true"]');
  focusElement(title || main);
}

export function SpaNavigationContext() {
  const { pathname } = useLocation();
  const previousPathnameRef = useRef(pathname);

  useEffect(() => {
    document.title = `${getSpaPageName(pathname)} | FullBook`;
  }, [pathname]);

  useEffect(() => {
    const previousPathname = previousPathnameRef.current;
    previousPathnameRef.current = pathname;
    if (previousPathname === pathname) {
      return undefined;
    }

    const frameId = window.requestAnimationFrame(focusNewRouteContent);
    return () => window.cancelAnimationFrame(frameId);
  }, [pathname]);

  const handleSkipLink = (event) => {
    const main = getMainContent();
    if (!main) return;
    event.preventDefault();
    focusElement(main);
    main.scrollIntoView({ block: "start" });
  };

  return (
    <a
      href="#main-content"
      onClick={handleSkipLink}
      className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-[100] focus:rounded-sm focus:bg-slate-900 focus:px-4 focus:py-3 focus:text-sm focus:font-medium focus:text-white focus:shadow-lg"
      data-testid="skip-to-main-content"
    >
      Vai al contenuto principale
    </a>
  );
}
